import { useState, useEffect } from 'react';

import * as gatewayRegistrationRequestService from '@frolight/services/api/gatewayRegistrationRequestService';

const useGatewayRegistrationRequestsForUserData = (userId) => {

  const [ loading, setLoading ] = useState(true);
  const [ data, setData ] = useState(null);
  const [ error, setError ] = useState(null);

  useEffect(() => {
    let mounted = true;
    
    const abortController = new AbortController();

    const runEffect = async () => {
      if (mounted) setLoading(true);
      try {
        const getRegistrationRequestsResponse = await gatewayRegistrationRequestService.findRegistrationRequestsByUserId(
          abortController, { userId }
        );
        if (mounted) setData(getRegistrationRequestsResponse.data);
      } catch (err) {
        if (mounted) setError(err);
      } finally {
        if (mounted) setLoading(false);
      }
    };

    if (userId) {
      runEffect();
    }

    return () => {
      mounted = false;
      abortController.abort();
    }

  }, [ userId ]);

  return { loading, error, data };
};

export default useGatewayRegistrationRequestsForUserData;